var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 376,
    viewBox: "0 0 376 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3853_32244)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.676 0.45166H127.006C121.54 0.45166 117.108 4.88326 117.108 10.3499V365.35C117.108 370.817 121.54 375.249 127.006 375.249H349.676C355.143 375.249 359.574 370.817 359.574 365.35V10.3499C359.574 4.88326 355.143 0.45166 349.676 0.45166Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.02 356.373H335.172C340.505 356.373 344.831 351.857 344.831 346.285V26.2673C344.831 20.6951 340.505 16.1794 335.172 16.1794H163.298",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M375.365 179.826H257.458V237.698H375.365V179.826Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.918 205.131C362.514 205.131 364.618 203.027 364.618 200.43C364.618 197.834 362.514 195.73 359.918 195.73C357.321 195.73 355.217 197.834 355.217 200.43C355.217 203.027 357.321 205.131 359.918 205.131Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347.703 200.43H279.3",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M359.918 221.789C362.514 221.789 364.618 219.685 364.618 217.089C364.618 214.493 362.514 212.388 359.918 212.388C357.321 212.388 355.217 214.493 355.217 217.089C355.217 219.685 357.321 221.789 359.918 221.789Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M347.703 217.089H279.3",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M333.055 152.84C333.055 152.84 333.917 146.546 320.957 144.807C320.957 144.807 320.971 138.706 301.567 139.497C284.34 140.197 283.428 141.922 283.428 141.922C283.428 141.922 286.878 135.324 288.382 132.773C289.881 130.222 294.261 121.488 287.966 118.937C281.676 116.386 278.217 125.191 276.063 127.982C273.909 130.772 221.293 186.423 221.293 186.423C221.293 186.423 210.139 116.607 136.21 100.947H114.092C68.9583 110.506 47.2246 140.251 37.1367 161.971C37.1909 162.133 37.2496 162.292 37.3038 162.45C42.4471 177.157 47.5091 191.905 51.7538 206.901C53.8084 214.158 67.6894 208.757 67.6894 208.757L37.1367 356.369H192.14L179.799 216.077C179.799 216.077 187.769 242.457 218.805 241.721C253.399 240.904 274.595 190.139 294.103 175.473C294.103 175.473 303.41 167.412 326.281 168.753C326.281 168.753 332.757 169.675 333.718 165.123C333.718 165.123 338.225 164.156 338.397 159.591C338.568 155.03 333.055 152.827 333.055 152.827V152.84Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M309.226 158.598C315.945 158.62 322.809 158.661 329.167 160.833C330.088 161.149 331.004 161.51 331.781 162.097C332.558 162.684 333.185 163.52 333.344 164.477",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M306.277 151.025C314.997 150.19 323.843 150.623 332.44 152.312",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M304.615 145.209C310.057 144.387 315.606 144.283 321.075 144.902",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M284.407 140.445C283.292 142.31 283.134 144.622 283.522 146.758C283.91 148.894 284.795 150.903 285.681 152.89",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250.374 155.992C255.738 162.684 262.918 167.936 271.462 172.117C271.019 175.829 270.197 179.072 269.023 181.88C272.401 180.742 275.855 178.534 279.359 175.649C279.359 175.649 284.706 177.613 287.673 178.48",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M278.934 190.889C264.091 188.153 250.441 179.428 241.73 167.11",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220.679 186.879C218.172 189.322 215.671 191.761 213.165 194.203",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.976 133.92H148.799C146.948 133.92 145.304 135.089 144.69 136.832L123.069 198.471C122.076 201.302 124.175 204.264 127.178 204.264H176.579C180.363 204.264 183.732 201.876 184.983 198.304L206.378 137.311C206.96 135.654 205.728 133.92 203.976 133.92Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.951 145.498C174.953 146.5 174.953 148.126 173.951 149.129C172.948 150.131 171.323 150.131 170.32 149.129C169.318 148.126 169.318 146.5 170.32 145.498C171.323 144.495 172.948 144.495 173.951 145.498Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.087 171.025C147.087 171.025 150.704 170.239 149.264 166.676C147.968 163.47 129.291 155.762 97.2075 172.361C93.9337 174.055 90.985 175.613 88.3208 177.04C90.7141 185.235 96.2457 200.887 105.932 211.223C113.459 202.666 121.66 194.772 131.377 193.359C148.546 190.866 133.978 187.24 133.978 187.24C133.978 187.24 146.798 187.1 146.798 184.152C146.798 180.232 136.439 179.916 132.041 179.961C130.844 180.002 130.099 180.011 130.099 180.011C130.099 180.011 130.853 179.975 132.041 179.961C136.913 179.794 149.399 179.081 150.578 176.073C152.05 172.33 147.083 171.02 147.083 171.02L147.087 171.025Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.041 179.961C136.439 179.916 146.798 180.232 146.798 184.152C146.798 187.1 133.978 187.24 133.978 187.24C133.978 187.24 148.546 190.866 131.377 193.359C121.66 194.772 113.459 202.666 105.932 211.223C96.2457 200.887 90.7141 185.235 88.3208 177.04C90.985 175.613 93.9337 174.055 97.2075 172.361C129.291 155.762 147.968 163.47 149.264 166.676C150.704 170.239 147.087 171.025 147.087 171.025L147.083 171.02C147.083 171.02 152.05 172.33 150.578 176.073C149.399 179.081 136.913 179.794 132.041 179.961ZM132.041 179.961C130.844 180.002 130.099 180.011 130.099 180.011C130.099 180.011 130.853 179.975 132.041 179.961Z",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.244 171.598C133.64 170.6 139.989 170.537 146.035 171.056",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0767 192.086L100.522 132.949L93.5998 107.21C93.5998 107.21 60.7396 119.122 33.3253 157.857C0.898572 203.677 -10.6705 229.895 13.4023 248.87C37.4751 267.844 77.0591 240.285 89.4184 229.434C94.7829 224.725 100.161 217.78 105.932 211.223C96.2505 200.887 90.7144 185.235 88.3211 177.04C66.0816 188.988 64.0767 192.086 64.0767 192.086Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.595 107.21C93.595 107.21 60.7349 119.122 33.3205 157.857C0.898305 203.677 -10.6707 229.895 13.4021 248.87C37.4749 267.844 77.0588 240.285 89.4181 229.434C94.7827 224.725 100.161 217.78 105.932 211.223C96.2502 200.887 90.7141 185.235 88.3208 177.04C66.0814 188.988 64.0764 192.086 64.0764 192.086L81.8138 171.165",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0479 204.237C51.9428 200.747 72.516 186.026 88.3207 177.04",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M173.485 57.4568C169.773 52.7922 163.501 50.7827 159.668 46.2129C155.987 41.8237 154.863 35.7999 151.535 31.1398C145.362 22.4924 135.044 25.4004 134.357 25.5901C128.704 26.0055 122.594 22.4427 116.747 23.3548C111.608 24.1541 107.666 28.2272 104.369 32.2506C101.073 36.274 97.7628 40.6678 92.9356 42.5959C88.8761 44.217 84.2972 43.8468 80.0796 44.9937C70.8136 47.518 64.7175 58.0032 66.5644 67.4228C68.4158 76.8469 77.5283 84.1306 87.1285 84.4242C90.6959 84.5325 94.3129 83.8055 97.8125 84.5145C100.373 85.0338 102.762 86.3027 105.358 86.5962C110.483 87.1742 115.184 83.9049 120.215 82.7669C128.605 80.8658 137.04 84.966 145.502 86.533C151.228 87.5941 157.27 87.4632 162.729 85.4311C168.189 83.4036 173.011 79.3486 175.314 73.9976C177.617 68.6466 177.116 62.0176 173.485 57.4568Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M141.009 61.8007C141.009 61.8007 142.251 55.8762 146.979 57.0638C151.707 58.2515 154.114 69.4502 140.057 72.0557L141.014 61.8007H141.009Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.702 62.8306C147.702 62.8306 143.195 64.2124 141.696 67.3914",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M107.21 61.8007C107.21 61.8007 105.968 55.8762 101.24 57.0638C96.5126 58.2515 94.1058 69.4502 108.163 72.0557L107.206 61.8007H107.21Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.522 62.8306C100.522 62.8306 105.029 64.2124 106.528 67.3914",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M140.327 110.673L146.491 102.441L130.65 88.7048L124.111 110.877L117.573 88.7048L101.728 102.441L107.891 110.673L104.428 113.739L124.098 158.178V158.232L124.111 158.205L124.121 158.232V158.178L143.791 113.739L140.327 110.673Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M132.516 103.254L124.09 141.845L114.431 103.254V78.197H132.516V103.254Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M126.031 132.949L121.714 152.28",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.16 58.3646C143.931 72.0379 134.597 87.8832 124.369 87.8832C114.141 87.8832 106.275 72.9004 105.85 59.1187C105.516 48.3535 131.806 42.5328 132.56 35.7188C133.545 42.2935 140.562 46.0324 142.16 58.3646Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3853_32244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 236,
    width: 162,
    height: 121
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M294.672 236.492H133.012V356.373H294.672V236.492Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3853_32244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.669 381.719C241.125 380.554 243.64 379.281 245.356 377.172C247.072 375.063 247.763 371.875 246.259 369.608C245.194 368.005 243.248 367.125 242.277 365.459C240.949 363.196 241.915 360.162 243.753 358.292C245.591 356.418 248.102 355.407 250.495 354.328C256.989 351.392 263.22 347.491 267.627 341.896C272.035 336.301 274.419 328.801 272.689 321.887C270.964 314.974 264.557 309.14 257.431 309.271C252.17 309.37 247.488 312.427 243.13 315.376C232.148 322.809 221.116 330.282 211.39 339.291C201.663 348.304 193.21 358.988 188.446 371.365C186.712 375.867 185.47 380.694 185.989 385.49C186.509 390.286 189.046 395.063 193.327 397.294C200.245 400.902 206.12 394.503 212.338 392.399C221.311 389.355 230.112 385.783 238.669 381.719Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.645 355.023C155.527 343.761 160.431 330.517 171.102 326.34C175.468 324.633 181.275 323.743 182.531 319.228C183.023 317.467 182.598 315.584 182.02 313.85C179.943 307.641 175.911 302.281 173.274 296.284C170.637 290.292 169.598 282.859 173.378 277.512C176.633 272.906 182.887 271.046 188.437 272.03C193.991 273.015 198.859 276.447 202.67 280.606C214.117 293.082 216.723 311.759 213.336 328.349C209.954 344.94 201.361 359.95 192.582 374.427C190.614 377.678 188.523 381.029 185.335 383.097C172.384 391.514 159.442 364.61 157.641 355.019L157.645 355.023Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.22 292.856C194.637 297.702 196.384 309.537 193.463 318.799C190.537 328.06 184.179 335.773 179.446 344.253C174.718 352.734 171.63 363.255 175.771 372.038",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.106 341.449C197.464 337.254 202.86 333.7 205.163 328.105C208.505 320.009 204.206 311.045 202.07 302.552C198.241 287.329 202.187 269.904 213.648 259.179C225.104 248.45 244.097 245.971 256.975 254.939C261.644 258.19 265.541 263.089 266.034 268.761C266.603 275.282 262.683 281.31 258.483 286.331C254.284 291.357 249.488 296.257 247.705 302.556C244.548 313.732 251.818 325.631 249.651 337.042C247.398 348.891 235.905 356.441 225.045 361.693C218.927 364.65 212.618 367.4 207.01 371.275C200.58 375.718 197.875 380.943 193.68 387.201C189.209 393.866 183.98 392.679 181.379 385.49C178.914 378.685 179.261 370.588 180.837 363.634C182.729 355.285 186.92 347.414 193.106 341.454V341.449Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.199 267.05C229.705 273.353 223.46 286.087 224.905 298.248C225.858 306.272 229.84 313.949 229.199 322.005C228.508 330.706 222.52 338.089 215.878 343.752C209.235 349.415 201.64 354.025 195.811 360.523C189.985 367.021 186.084 376.233 188.852 384.51",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M146.708 356.373H272.622",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M298.085 112.674C320.523 112.674 338.712 94.5007 338.712 72.0829C338.712 49.6651 320.523 31.4919 298.085 31.4919C275.647 31.4919 257.458 49.6651 257.458 72.0829C257.458 94.5007 275.647 112.674 298.085 112.674Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M323.748 65.3547H304.814V46.4207H291.357V65.3547H272.418V78.8112H291.357V97.7453H304.814V78.8112H323.748V65.3547Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M250.585 55.4248H184.693",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M250.585 72.0828H184.693",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M250.585 88.741H184.693",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M106.609 271.791H11.8442V356.373H106.609V271.791Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8602 255.033H127.35C131.134 255.033 134.209 258.109 134.209 261.893V326.358C134.209 330.142 131.134 333.217 127.35 333.217H85.8602C82.0761 333.217 79.001 330.142 79.001 326.358V261.893C79.001 258.109 82.0761 255.033 85.8602 255.033Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.609 261.55V326.701",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4427 263.794C100.026 266.377 100.026 270.558 97.4427 273.141C94.8598 275.724 90.6783 275.724 88.0954 273.141C85.5125 270.558 85.5125 266.377 88.0954 263.794C90.6783 261.211 94.8598 261.211 97.4427 263.794Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4863 265.185L96.052 271.75",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4427 281.003C100.026 283.586 100.026 287.767 97.4427 290.35C94.8598 292.933 90.6783 292.933 88.0954 290.35C85.5125 287.767 85.5125 283.586 88.0954 281.003C90.6783 278.42 94.8598 278.42 97.4427 281.003Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4863 282.394L96.052 288.959",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4427 298.212C100.026 300.795 100.026 304.976 97.4427 307.559C94.8598 310.142 90.6783 310.142 88.0954 307.559C85.5125 304.976 85.5125 300.795 88.0954 298.212C90.6783 295.629 94.8598 295.629 97.4427 298.212Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4863 299.603L96.052 306.168",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7691 326.701C96.4202 326.701 99.38 323.741 99.38 320.09C99.38 316.439 96.4202 313.479 92.7691 313.479C89.118 313.479 86.1582 316.439 86.1582 320.09C86.1582 323.741 89.118 326.701 92.7691 326.701Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4863 316.812L96.052 323.373",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M125.119 263.794C127.702 266.377 127.702 270.558 125.119 273.141C122.536 275.724 118.355 275.724 115.772 273.141C113.189 270.558 113.189 266.377 115.772 263.794C118.355 261.211 122.536 261.211 125.119 263.794Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M117.163 265.185L123.728 271.75",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M125.119 281.003C127.702 283.586 127.702 287.767 125.119 290.35C122.536 292.933 118.355 292.933 115.772 290.35C113.189 287.767 113.189 283.586 115.772 281.003C118.355 278.42 122.536 278.42 125.119 281.003Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M117.163 282.394L123.728 288.959",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M125.119 298.212C127.702 300.795 127.702 304.976 125.119 307.559C122.536 310.142 118.355 310.142 115.772 307.559C113.189 304.976 113.189 300.795 115.772 298.212C118.355 295.629 122.536 295.629 125.119 298.212Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M117.163 299.603L123.728 306.168",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M120.445 326.701C124.096 326.701 127.056 323.741 127.056 320.09C127.056 316.439 124.096 313.479 120.445 313.479C116.794 313.479 113.834 316.439 113.834 320.09C113.834 323.741 116.794 326.701 120.445 326.701Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M117.163 316.812L123.728 323.373",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8032 245.727V237.879H32.6478V245.727C28.4167 248.689 25.897 253.53 25.897 258.696V343.088C25.897 347.301 29.3108 350.72 33.5239 350.72H61.9226C66.1357 350.72 69.5495 347.306 69.5495 343.088V258.696C69.5495 253.53 67.0298 248.689 62.7987 245.727H62.8032Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M33.939 228.039H60.9966C64.0492 228.039 66.5328 230.518 66.5328 233.575C66.5328 236.628 64.0537 239.111 60.9966 239.111H33.939C30.8864 239.111 28.4028 236.632 28.4028 233.575C28.4028 230.518 30.8819 228.039 33.939 228.039Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8761 261.689H37.0688V312.617H64.8761V261.689Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8761 315.57H37.0688V324.082H64.8761V315.57Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M375.365 246.138H257.458V304.01H375.365V246.138Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M359.918 271.448C362.514 271.448 364.618 269.343 364.618 266.747C364.618 264.151 362.514 262.046 359.918 262.046C357.321 262.046 355.217 264.151 355.217 266.747C355.217 269.343 357.321 271.448 359.918 271.448Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M347.703 266.747H279.3",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M359.918 288.106C362.514 288.106 364.618 286.001 364.618 283.405C364.618 280.809 362.514 278.704 359.918 278.704C357.321 278.704 355.217 280.809 355.217 283.405C355.217 286.001 357.321 288.106 359.918 288.106Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M347.703 283.405H279.3",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3853_32244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375.7,
    height: 375.7,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessFrame);
export default __webpack_public_path__ + "static/media/BusinessFrame.39dc0817eae42f9f3f83bf7fb1f35bdc.svg";
export { ForwardRef as ReactComponent };